import React from 'react';
import { useAsyncAction } from '~hooks';

import { Spinner } from '~components';
import ClickableIcon, { ClickableIconProps } from '~components/ClickableIcon';
import Icon, { faCheck, faCircleExclamation } from '~components/icon';

interface ComponentProps extends ClickableIconProps {
  onClick: () => Promise<void>;
  onError?: (error: unknown) => void;
  successTitle?: string;
  errorTitle?: string;
  resetDelay?: number;
  spinnerDataCy?: string;
}

const AsyncActionIcon: React.FC<ComponentProps> = ({
  onClick,
  onError,
  successTitle = 'Done',
  errorTitle = 'Action failed',
  resetDelay = 3000,
  spinnerDataCy,
  ...clickableIconProps
}) => {
  const { state, handleClick } = useAsyncAction({ onClick, onError, resetDelay });

  if (state === 'loading') {
    return <Spinner type="clip" size={16} loading={true} className="ms-2 me-2" dataCy={spinnerDataCy} />;
  }

  if (state === 'success') {
    return <Icon icon={faCheck} className="text-success ms-2 me-2" title={successTitle} />;
  }

  if (state === 'error') {
    return <Icon icon={faCircleExclamation} className="text-danger ms-2 me-2" title={errorTitle} />;
  }

  return (
    <ClickableIcon
      {...clickableIconProps}
      onClick={handleClick}
      disabled={clickableIconProps.disabled || state !== 'idle'}
    />
  );
};

export default AsyncActionIcon;
